import React, { useEffect } from 'react';
import Loader from '../layout/Loader';
import { useGetAdminOrdersQuery } from '../../redux/api/bookingApi';
import MetaData from '../layout/MetaData';
import AdminLayout from '../layout/AdminLayout';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';

const ListOrders = () => {
  const { data, isLoading, error } = useGetAdminOrdersQuery();

  useEffect(() => {
    if (error) toast.error(error?.data?.message);
  }, [error]);

  if (isLoading) return <Loader />;

  const statusColors = {
    'Pending': 'warning',
    'Processing': 'info',
    'Shipped': 'primary',
    'Delivered': 'success',
    'Cancelled': 'danger',
  };

  return (
    <AdminLayout>
      <MetaData title="All Bookings" />
      <div className="container py-4">
        <h2 className="mb-4">{data?.orders?.length || 0} Bookings</h2>

        <div className="card">
          <div className="table-responsive">
            <table className="table mb-0">
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Status</th>
                  <th>Distance</th>
                  <th>Total Amount</th>
                  <th>Vehicle</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {data?.orders?.map((order) => (
                  <tr key={order?._id}>
                    <td>{order?._id.substring(0, 8)}...</td>
                    <td>
                      <span className={`badge badge-${statusColors[order?.orderStatus] || 'secondary'}`}>
                        {order?.orderStatus}
                      </span>
                    </td>
                    <td>{order?.googleMap?.distance}</td>
                    <td>{order?.totalAmount} PKR</td>
                    <td>{order?.userAddressInfo?.vehicle}</td>
                    <td>
                      <Link to={`/admin/orders/${order?._id}`} className="btn btn-sm btn-outline-primary">
                        <i className="fa fa-eye" />
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default ListOrders;